import React, { useState } from "react";

const NotYetConfirmedCheckbox = ({ studentsState, updateStudents }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <label className="flex items-center gap-2 text-sm text-gray-800 relative">
      <input
        type="checkbox"
        checked={studentsState.notYetConfirmed}
        onChange={(e) => {
          const checked = e.target.checked;
          updateStudents({
            notYetConfirmed: checked,
            ...(checked
              ? {
                  selectedGroups: [],
                  groupStudentsMap: {},
                  studentMap: {},
                  customStudents: [],
                }
              : {
                  notYetConfirmedDetails: {
                    approxNumStudents: "",
                    yearLevels: "",
                    description: "",
                  },
                }),
          });
        }}
      />
      <span>Cannot specify which students/groups yet</span>

      {/* Tooltip trigger */}
      <span
        className="text-blue-500 cursor-pointer text-xs"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        ⓘ
      </span>

      {/* Tooltip content */}
      {showTooltip && (
        <div className="absolute left-0 top-full mt-2 w-64 bg-white border border-gray-300 text-gray-700 text-sm px-3 py-2 rounded-md shadow-md z-50">
          Select this checkbox if the desired class or group has not yet been
          created in the College Timetable or TASS at this current time.
        </div>
      )}
    </label>
  );
};

export default NotYetConfirmedCheckbox;
